<template>
  <div class="course-card hover-gradient">
    <img :src="course.image" :alt="course.title" class="course-img" />
    
    <div class="course-content">
    <div class="course-info">
      <div class="course-details">
        <p class="course-title">{{ course.name }}</p>
        <p class="course-subtitle">{{ course.description }}</p>
      </div>
      <div class="course-meta">
        <span>
          {{ course.total_video_duration }} ساعات
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-clock-history" viewBox="0 0 16 16">
            <path
              d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
            <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
            <path
              d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
          </svg>
        </span>
      </div>
    </div>
        <div class="items">
          <div
            class="item homework"
          >
            <i class="bi bi-calendar-plus-fill"></i>
            <span>{{ course.homework_count }} واجب</span>
          </div>
          <div
            class="item exam"
          >
            <i class="bi bi-calendar2-range-fill"></i>
            <span>{{ course.exam_count }} اختبار</span>
          </div>
          <div class="item video">
            <i class="bi bi-play-btn-fill"></i>
            <span>{{ course.video_count }} فيديو</span>
          </div>
        </div>

      <button 
        class="watch-btn"
        @click="handleCourseClick(course.id)"
      >
        {{ course.subscription_status }}
      </button>
  </div>
  </div>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleCourseClick(id) {
      const token = this.$store.state.studentToken;
      if (token) {
        this.$router.push({ name: "CourseDetails", params: { id } });
      } else {
        this.$router.push("/login");
      }
    }
  }
};
</script>


<style scoped>
.course-card {
  background: #fff;
  padding: 12px;
  border-radius: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  height: min-content;
}
.course-content {
  position: relative;
  z-index: 1;
}
.course-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(0,0,0,.12);
  background-color: transparent;
}
.course-details {
    display: flex;
    flex-direction: column;
    gap: 25px;
}
.course-img {
  width: 100%;
  height: auto;
  max-height: 360px;
  object-fit: cover;
  border-radius: 24px;
}
.course-info {
  text-align: right;
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding: 16px 0;
}
.course-title {
  font-size: 22px;
  font-weight: bold;
  color: #000;
  margin: 0;
}
.course-subtitle {
  font-size: 14px;
  color: #7F8685;
  font-weight: 500;
  margin: 0;
  padding: 0;
}
.course-meta {
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #000;
}
.course-meta span {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 500;
  align-self: end;
}
.course-meta .tag {
  background: #7F868533;
  padding: 4px 8px;
  border-radius: 25px;
  font-weight: 500;
  font-size: 14px;
}
.watch-btn {
  background: #ff9800;
  color: #fff;
  border: none;
  padding: 12px;
  border-radius: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 18px;
  font-weight: bold;
  transition: background 0.3s;
}
.watch-btn:hover {
  background: #e68900;
}
.items {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin: 30px 0;
}
.item {
  padding: 8px 12px;
  border-radius: 24px;
  display: flex;
  align-items: center;
  gap: 15px;
  position: relative;
  z-index: 1;
}
.item.homework {
  background-color: #FF770033;
  color: #FF7700;
}
.item.exam {
  display: flex;
  flex-direction: row !important;
  background-color: #15C01B33;
  color: #15C01B;
}
.item.video {
  background-color: #15C0BD33;
  color: #15C0BD;
}
.item i {
  position: relative;
  z-index: 1;
}
</style>
